
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fans",
      function () {
        return require("private-next-pages/fans.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fans"])
      });
    }
  